module.exports = __webpack_public_path__ + "static/media/coronavirus_fever.07794017.jpeg";